import { __awaiter } from "tslib";
import conf from '../../conf';
import { getContact } from '../helpers';
import { getOrderSubtotal } from '../../selectors/order';
import { receiveOrderSalesTax, fetchingOrderSalesTax } from '../../store/order';
import fetch from '../fetch';
import { getSalesTax } from './avatax';
export const getOrderSalesTax = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { offer: { offerFlow, taxCode }, system: { activeFlow }, esb: { esbPartner }, } = state;
    const contact = getContact(state);
    if (contact == null || contact === 'ERROR') {
        dispatch(receiveOrderSalesTax(null));
        return;
    }
    const subtotal = getOrderSubtotal(state);
    if (subtotal === 0) {
        dispatch(receiveOrderSalesTax(0));
        return;
    }
    if (activeFlow === 'esb-trial' && esbPartner === 'big-commerce') {
        dispatch(fetchingOrderSalesTax(true));
        const body = {
            items: [{
                    amount: subtotal,
                    taxCode: 'SW052000',
                    id: 'esb-trial-big-commerce-partner',
                }],
            contact,
        };
        const result = yield getSalesTax(body, dispatch);
        dispatch(fetchingOrderSalesTax(false));
        if (result.ok) {
            dispatch(receiveOrderSalesTax(result.value.totalTaxCalculated));
            return;
        }
        dispatch(receiveOrderSalesTax(null));
        return;
    }
    if (!taxCode) {
        dispatch(receiveOrderSalesTax(null));
        return;
    }
    const items = [{
            id: offerFlow,
            amount: subtotal,
            taxCode,
        }];
    const body = { contact, items };
    const postParams = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    };
    dispatch(fetchingOrderSalesTax(true));
    const result = yield fetch(dispatch, { showLoadingWheel: false })(`${conf.API_URL}/api/offers/salestax`, postParams);
    if (result.ok) {
        const salesTax = result.value.totalTaxCalculated;
        dispatch(receiveOrderSalesTax(salesTax));
    }
    else {
        dispatch(receiveOrderSalesTax(null));
    }
    dispatch(fetchingOrderSalesTax(false));
});
